/* eslint-disable no-unused-expressions */
/******************************************************************************
 * JsonView Hook
 * version: 1.0.1, release: 10.06.2019
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * - testing recursion
 * - exclude dom, react elements
 * 
******************************************************************************/

/*
// https://stackoverflow.com/questions/62121310/how-to-handle-streaming-data-using-fetch
const response = await fetch('/data.json');
if (!response.ok)
    throw new Error(await response.text());
for await (const chunk of response.body.getIterator()) {
    console.log('got', chunk);
}
*/

import React, { useState, useEffect } from 'react';
import './JsonView.scss';
import TweenS from '../../utils/TweenS';
// import ResizeObserver from 'resize-observer-polyfill'; // https://github.com/que-etc/resize-observer-polyfill
// onmount:

const defaultSetup = {
	lineHeight		: 20,
	listInline		: true,
	first			: 0,
	last			: 0,
	scrollTop		: 0,
	totalNodes		: 0,
	maxLines		: 10000,
	offset			: 0,
	showCounts		: true,
	showPath		: false,
	isWheel			: false,
	ref_view		: null,
	resizeObserver	: null,
	source			: null,
	data			: null,
	ref_elements	: null,
	elements		: null,
}


//============================================================================= JsonView Hook
export default function JsonView2(props) {
	const [setup] = useState(() => {
		let s = {...defaultSetup};
		if (props.setup) for (let e in props.setup) s[e] = props.setup[e];
		return s;
	})
	const [jsonItems, setJsonItems] = useState([]);
	const [pathItems, setPathItems] = useState([]);


	const [tween] = useState(e => {
		return new TweenS({onUpdate:e => {
			// console.log(e);
			setup.scrollTop = e.value;
			setup.ref_view.scrollTop = e.value;
		}, duration:0.3}
	)})


	const addScroll = e => {
		if (!setup.ref_view) return;

		clearTimeout(setup.isWheel);
		setup.isWheel = setTimeout(e => {setup.isWheel = null}, 300);
		let t = Math.round(setup.ref_view.scrollTop / setup.lineHeight) + e;
		setup.ref_view.scrollTop = t * setup.lineHeight;
	}


	useEffect(() => {
		window.addEventListener('keydown', e => {
			if (e.key === 'ArrowRight'){
				addScroll(1);
			}else if (e.key === 'ArrowLeft'){
				addScroll(-1);
			}
		}, false);

		// setup.resizeObserver = new ResizeObserver(entries => entries.map(updateSize));
		// setup.resizeObserver.observe(setup.ref_view);
		
		// window.addEventListener('resize', updateSize, false);
		// setup.ref_view.addEventListener("mousewheel", wheelDistance); 
		// setup.ref_view.addEventListener("DOMMouseScroll", wheelDistance); 

// const preventDefault = e => e.preventDefault();
// setup.ref_view.addEventListener('wheel', preventDefault);

		if (setup.source) loadData(setup.source);

		return (e => {
			// window.removeEventListener('resize', updateSize);
			setup.resizeObserver?.unobserve(setup.ref_view);
		})
	}, [])


	const setViewRef = e => {
		if (!e) return;

		setup.resizeObserver?.unobserve(setup.ref_view);

		setup.ref_view = e;
		setup.resizeObserver = new ResizeObserver(entries => entries.forEach(onResize));
		setup.resizeObserver.observe(setup.ref_view);
	}


	useEffect(() => {
		if (props.source !== undefined && props.source !== setup.source){
			loadData(props.source);

		}else if (props.sourceData !== undefined && props.sourceData !== setup.data){
			parseData(props.sourceData);
		}
	}, [props.source, props.sourceData])


	const binArrayToJson = binArray => 
	{
		let str = '';
		for (let i = 0; i < binArray.length; i++) {
			str += String.fromCharCode(parseInt(binArray[i]));
		}
		return str;
	}


	const loadData = async source => {
		setup.source = source;		//source url
		setup.data = null;			//source data
		// setup.first = 0;			//first index
		// setup.last = 0;				//last index
		setup.scrollTop = 0;
		setup.totalNodes = 0;
		setup.offset = 0;

		setup.ref_view.scrollTop = 0;
		setup.ref_elements.style.top = '0px';
		setup.elements = null;		//list of all elements
		setJsonItems([]);			//clear visible items
		setPathItems([]);

		let result = '';

		fetch(source)
		// Retrieve its body as ReadableStream
			.then(response => response.body)
			.then(body => {
				const reader = body.getReader();
				reader.read()
					.then((function process({done, value}) {
						// console.log(done, value);
						// console.log('ok');

						if (value) result += binArrayToJson(value);
// test(result);
						if (done){
							// console.log(result);
							// result = binArrayToJson(result);
							return parseData(JSON.parse(result));
							// return;
						}
return reader.read().then(process);	//read next
					}))
			});
	}


	const test = e => {
		let a = e.split(',');
		a.forEach(e => {
			console.log(e);
		})
	}


	const onResize = e => {
		if (!setup.elements) return;
		let w = setup.ref_view.clientWidth;
		let h = setup.ref_view.clientHeight;

		if (w === setup.width && h === setup.height) return;
// console.log('resize', w, setup.ref_view.clientHeight, e.contentRect?.width, e.contentRect?.height);

		setup.width = w;
		setup.height = h;

		updateSize();
	}


	const updateSize = (e) => {
		if (!setup.elements || !setup.ref_container) return;

		let el = setup.elements[0];
		let n = 1;
		while(el.x){
			n ++;
			el = el.x;
		}

		setup.openNodes = n;

		if (n > setup.maxLines) n = setup.maxLines;
		setup.containerHeight = n * setup.lineHeight;
		setup.scrollHeight = setup.containerHeight - setup.height;
		setup.ref_container.style.height = setup.containerHeight + 'px';

		setup.visibleNodes = Math.floor (setup.height / setup.lineHeight);

		setup.offsetNodes = Math.max(setup.openNodes - setup.maxLines, 0);
		setup.currentOffset = 0;

		onScroll();
	}


	const parseData = data => {
		console.log('---parse data ...', data);
		setup.data = data;		//set source data

		// let t = performance.now();

		// data = JSON.parse(JSON.stringify(data))		//create a working deep copy

		setup._lookup = []								//recursion block list
		setup.elements = parseJsonElement(data);		//parse all json elements
		setup._lookup.forEach(e => delete e.__)			//clear recursive blocker flags

		setup.totalNodes = setup.elements?.length || 0
		if (setup.totalNodes === 0) return

		// console.log('lines total:', setup.totalNodes);
		setup.elements.forEach((el, i) => el.x = setup.elements[i+1]);		//create link-list to next item

		// console.log('creating:', performance.now() - t, setup.totalNodes);

// setup.ref_container.style.height = ((num * setup.lineHeight) + 'px');

		updateSize(false);

// console.log('height:', all.length * setup.lineHeight, setup.ref_container.style.height);	//max height = 33554400px = 1864133 lines
// setup.ref_container.style.height = 1000;

		// console.log((all.length - 300000) * setup.lineHeight, setup.ref_container.clientHeight, setup.ref_container.style.height);

		// let last = Math.ceil (h0 / setup.lineHeight);
		let last = setup.visibleNodes;

		// setup.first = 0;
		// setup.last = last;
setup.scrollTop = 0;
// setup.offset = 180;

		getJsonElements(0, last);
	}


	// ------------------------------------------------------------------------ parseJsonElement
	/*
		i	: index
		l	: label
		v	: prefix
		n	: number of sub-elements
		c	: node closed
		o	: closed item
		t	: node-type: a = array, o = object, string, number
		p	: parent-node id
		x	: next node
		h	: level,
		a	: full path (e.g. .firstNode.secondNode.list.0.value)
	*/
	
	// new
	const _parseJsonElement = (data, i = '', tab = '', e = [], p, h = -1, a = '') => {
		h++;
		let t = getType(data);
		let en, c, n, v;

		const addElement = (element) => e.push(element);

		if (t === 'f') {
			addElement({ i: e.length, p, l: tab + i, v: '(function)', t, h, a });
		} else if (t === 'a') {
			en = { i: e.length, p, l: tab + i, v: '[', n: data.length, c: true, t, h, a };
			if (data.length) {
				addElement(en);
				data.forEach((el, idx) => parseJsonElement(el, idx + ': ', tab + '\t', e, en.i, h, a + '.' + idx));
				c = { i: e.length, p: en.i, l: tab, v: ']', t, h, a };
				addElement(c);
				en.o = c;
			} else {
				en.v = '[]';
				addElement(en);
			}
		} else if (t === 'o') {
			if (data.__) return;
			data.__ = true;
			setup._lookup.push(data);

			en = { i: e.length, p, l: tab + i, v: '{', t, h, a };
			addElement(en);
			n = 0;

			Object.keys(data).forEach((key) => {
				if (key === '__' || ['FiberNode', 'HTMLElement', 'HTMLVideoElement'].includes(data[key]?.constructor?.name)) return;
				n++;
				parseJsonElement(data[key], key + ': ', tab + '\t', e, en.i, h, a + '.' + key);
			});

			en.n = n;
			if (n) {
				en.c = true;
				c = { i: e.length, p: en.i, l: tab, v: '}', t, h, a };
				addElement(c);
				en.o = c;
			} else {
				en.v = '{}';
			}
		} else {
			v = t === 's' ? '"' + data + '"' : String(data);
			addElement({ i: e.length, p, l: tab + i, v, t, h, a });
		}

		return e;
	}


	const parseJsonElement = (data, i='', tab='', e=[], p, h=-1, a='') => {

		const addElement = (element) => e.push(element);

		h ++;

		if (data === null || data === undefined){
			addElement({ i: e.length, p, l: tab + i, data, t:data, h, a });
			return e;
		}

		let t = getType(data);
		let en, c, n, v;

		if (t === 'f') {
			addElement({ i: e.length, p, l: tab + i, v: '(function)', t, h, a });
		} else if (t === 'a') {
			en = { i: e.length, p, l: tab + i, v: '[', n: data.length, c: true, t, h, a };
			if (data.length) {
				addElement(en);
				data.forEach((el, idx) => parseJsonElement(el, idx + ': ', tab + '\t', e, en.i, h, a + '.' + idx));
				c = { i: e.length, p: en.i, l: tab, v: ']', t, h, a };
				addElement(c);
				en.o = c;
			} else {
				en.v = '[]';
				addElement(en);
			}
		} else if (t === 'o') {
			if (data.__) return;
			data.__ = true;
			setup._lookup.push(data);

			en = { i: e.length, p, l: tab + i, v: '{', t, h, a };
			addElement(en);
			n = 0;

			Object.keys(data).forEach((key) => {
				if (key === '__' || ['FiberNode', 'HTMLElement', 'HTMLVideoElement'].includes(data[key]?.constructor?.name)) return;
				n++;
				parseJsonElement(data[key], key + ': ', tab + '\t', e, en.i, h, a + '.' + key);
			});

			en.n = n;
			if (n) {
				en.c = true;
				c = { i: e.length, p: en.i, l: tab, v: '}', t, h, a };
				addElement(c);
				en.o = c;
			} else {
				en.v = '{}';
			}
		} else {
			v = t === 's' ? '"' + data + '"' : String(data);
			addElement({ i: e.length, p, l: tab + i, v, t, h, a });
		}

		return e;
	}


	// s = string, n = number, b = boolean, o = object, a = array
	const getType = value => {
		let t = typeof value;
		return t === 'object'? Array.isArray(value)? 'a' : 'o'
			: t === 'boolean'? 'b'
			: t === 'string'? 's'
			: t === 'function'? 'f'
			: 'n'
	}


	const getJsonElements = (first, last) => {
		if (!setup.elements) return [];

// console.log('get', first, last);
		let e = [];
		let el = setup.elements[0];		//first element
		let n = first;
		while(n-- && el) el = el.x;			//search for first element

		n = last - first + 1;
		while(n-- && el){
			e.push(el);
			el = el.x;
		}

		setJsonItems(e);

if (!setup.showPath) return null;

		// console.log(e[0].h);
		let p = [];
		el = e[0];		//first visible element
		n = 1;
		// console.log(el);

		while(el.h > n){		//recursive path
			// console.log(el);
			el = el.x;
			n ++;
		}
		while(el.p){			//while parent
			el = setup.elements[el.p];
			p.unshift(el);		//append path node till root
		}
		setup.ref_path.style.height = (p.length * setup.lineHeight) + 'px';

		setPathItems(p);
	}


	const onWheel = e => {
		clearTimeout(setup.isWheel);
		setup.isWheel = setTimeout(e => {setup.isWheel = null}, 300);
	}

	const onScroll = (wheel=false) => {
		if (!setup.elements) return;

// console.log('---scroll');
		let sv = setup.ref_view;
		let t0 = sv.scrollTop;// + setup.offset;
		t0 = Math.round(t0 / setup.lineHeight) * setup.lineHeight;
		let r0 = t0 / setup.scrollHeight;
		r0 = r0 < 0? 0 : r0 > 1? 1: r0;

		if (setup.isWheel || wheel === true){		//scroll after wheel
			// setup.currentOffset = Math.floor(setup.offsetNodes * r0);
			// if (setup.currentOffset){
			// 	if (r0 > 0.9){
			// 		sv.scrollTop -= 180;
			// 		setup.currentOffset += 10;	
			// 	}
			// }
		}else{					//scroll from scroll-bar
			setup.currentOffset = Math.floor(setup.offsetNodes * r0);
		}

// sv.scrollTop = 10;

// console.log(sv.scrollTop / 18, setup.scrollHeight / 18);
		// setup.offset = 20;

		// let h0 = sv.clientHeight;
		let first = Math.floor (t0 / setup.lineHeight);			// + 5 //test-offset top;

		setup.ref_elements.style.top = (first * setup.lineHeight) + 'px';

		first += setup.currentOffset;
		// first += Math.floor(Math.random() * 20);
		// let last = Math.floor ((t0 + h0) / setup.lineHeight);	// - 5 //test-offset bottom;
		// let last = Math.min(first + setup.visibleNodes, setup.maxLines-1);
		let last = first + setup.visibleNodes;

// console.log(setup.currentOffset, first, last)
		// if (setup.first === 0 && setup.last === last) return;
		// setup.first = last;
		// setup.last = last;

// console.log(first, last);
		getJsonElements(first, last);

	}


	const onClick = el => {
		// console.log(el);
		if (!el.n) return;		//not a node element

		if (el.c){		//close now
			if (setup.listInline){
				el.x = el.o.x;
				el.v = el.t === 'a'? '[...]' : '{...}';
			}else{
				el.x = el.o;
			}
		}else{			//open now
			el.x = setup.elements[el.i+1];
			if (setup.listInline) el.v = el.t === 'a'? '[' : '{';
		}
		el.c = !el.c;

		updateSize(false);
		onScroll(true);
	}


	return (
		<div className='json-view' id={props.id}>
			<div className='json-main'
				onScroll={onScroll}
				// onWheel={onWheel}
				onWheel={onWheel}
				ref={setViewRef}
				>
				<div className='json-container' ref={e => setup.ref_container = e}>
					<div className='json-elements' ref={e => setup.ref_elements = e}>
						{/* use <pre> to show the tabs */}
						{/* <pre> */}
						{jsonItems.map((e, i) =>
							<JsonItem
								style={{top:i*setup.lineHeight+'px'}}
								key={e.i}
								onClick={() => onClick(e)}
								// label={e.l + (e.v || '')}
								label={e.l}
								value={e.v}
								count={e.n}
								type={e.t}
								level={e.h}
								id={e.i}
							/>
						)}
						{/* </pre> */}
					</div>
				</div>
			</div>

			{setup.showPath &&
				<div className='json-path'
					ref={e => setup.ref_path = e}
					>
					<pre>
					{pathItems.map((e, i) =>
						<JsonItem
							style={{top:i*setup.lineHeight+'px'}}
							key={e.i}
							onClick={() => onClick(e)}
							// label={e.l + (e.v || '') + '..'}
							label={e.l}
							value={e.v + '..'}
							count={e.n}
							type={e.t}
							level={e.h}
							id={e.i}
						/>
					)}
					</pre>
				</div>
			}
		</div>
	)
}

const JsonItem = props => {
	return (
		<div className='json-element' style={props.style} id={props.id} onClick={props.onClick}>
			<div className='line-nr'>{props.id + 1}</div>
			<div className='line-node' style={{marginLeft:props.level*2+'em'}}>{props.label}
				{props.count !== undefined && <span className='type-c'>{'('+props.count+')'}</span>}
				<span className={'type-' + props.type}>{props.value}</span>
			</div>
		</div>
		// <div><code>{e.data}</code></div>
	)
}
